import React from 'react'
import { withRouter } from 'react-router'
import { pageNames } from './pathParams'

// query params that only affect in-page state (PDP variant, PLP sort) and
// should not steal focus/scroll the page when they're the only thing changed
const IGNORED_FOCUS_RESET_PARAMS = ['variant', 'sort']
// selecting a sort/filter option also clears `page` as a side effect
// (see SortFilterDeps#constructQueryParam), so a dropped `page` shouldn't
// count as a "real" navigation on its own
const IGNORED_ON_REMOVE_PARAMS = ['page']

function isOnlyIgnoredParamsChanged(
  previousSearch,
  currentSearch,
  ignoredParams
) {
  const previousParams = new URLSearchParams(previousSearch || '')
  const currentParams = new URLSearchParams(currentSearch || '')

  ignoredParams.forEach(param => {
    previousParams.delete(param)
    currentParams.delete(param)
  })
  IGNORED_ON_REMOVE_PARAMS.forEach(param => {
    if (previousParams.has(param) && !currentParams.has(param)) {
      previousParams.delete(param)
    }
  })
  previousParams.sort()
  currentParams.sort()

  return previousParams.toString() === currentParams.toString()
}

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    const previousLocation = prevProps.location || {}
    const currentLocation = this.props.location || {}
    const isSamePathname =
      previousLocation.pathname === currentLocation.pathname
    const isSameSearch = previousLocation.search === currentLocation.search

    const isIgnoredParamOnlyChange =
      isSamePathname &&
      !isSameSearch &&
      isOnlyIgnoredParamsChanged(
        previousLocation.search,
        currentLocation.search,
        IGNORED_FOCUS_RESET_PARAMS
      )

    if ((isSamePathname && isSameSearch) || isIgnoredParamOnlyChange) {
      return
    }

    /**
     * @info
     * added condition to support tab index from header on page navigation except myaccount.
     */
    if (!window?.location?.pathname.includes(pageNames.myAccountPrefix)) {
      const container = document.getElementById('app-root')
      if (container) {
        container.tabIndex = -1
        container.focus()
        setTimeout(() => container.removeAttribute('tabindex'), 1000)
      }
    }
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { children } = this.props
    return children
  }
}

const ScrollToTopWithRouter = withRouter(ScrollToTop)

export { ScrollToTopWithRouter }
